// For notifications

var defaultWidth =
  window.screen.width > 768
    ? (window.screen.width * 1) / 3
    : window.screen.width;

var style = {
  Wrapper: {},
  Containers: {
    DefaultStyle: {
      position: "fixed",
      width: defaultWidth,
      padding: "10px 10px 10px 20px",
      zIndex: 9998,
      WebkitBoxSizing: "",
      MozBoxSizing: "",
      boxSizing: "",
      height: "auto",
      display: "inline-block",
      border: "0",
      fontSize: "14px",
      WebkitFontSmoothing: "antialiased",
      fontFamily: '"Roboto","Helvetica Neue",Arial,sans-serif',
      fontWeight: "400",
      color: "#FFFFFF"
    },

    tl: {
      top: "0px",
      bottom: "auto",
      left: "0px",
      right: "auto"
    },

    tr: {
      top: "0px",
      bottom: "auto",
      left: "auto",
      right: "0px"
    },

    tc: {
      top: "0px",
      bottom: "auto",
      margin: "0 auto",
      left: "50%",
      marginLeft: -(defaultWidth / 2)
    },

    bl: {
      top: "auto",
      bottom: "0px",
      left: "0px",
      right: "auto"
    },

    br: {
      top: "auto",
      bottom: "0px",
      left: "auto",
      right: "0px"
    },

    bc: {
      top: "auto",
      bottom: "0px",
      margin: "0 auto",
      left: "50%",
      marginLeft: -(defaultWidth / 2)
    }
  },

  NotificationItem: {
    DefaultStyle: {
      position: "relative",
      width: "100%",
      cursor: "pointer",
      borderRadius: "4px",
      fontSize: "14px",
      margin: "10px 0 0",
      padding: "10px",
      display: "block",
      WebkitBoxSizing: "border-box",
      MozBoxSizing: "border-box",
      boxSizing: "border-box",
      opacity: 0,
      transition: "all 0.5s ease-in-out",
      WebkitTransform: "translate3d(0, 0, 0)",
      transform: "translate3d(0, 0, 0)",
      willChange: "transform, opacity",

      isHidden: {
        opacity: 0
      },

      isVisible: {
        opacity: 1
      }
    },

    success: {
      borderTop: 0,
      backgroundColor: "#a1e82c",
      WebkitBoxShadow: 0,
      MozBoxShadow: 0,
      boxShadow: 0
    },

    error: {
      borderTop: 0,
      backgroundColor: "#fc727a",
      WebkitBoxShadow: 0,
      MozBoxShadow: 0,
      boxShadow: 0
    },

    warning: {
      borderTop: 0,
      backgroundColor: "#ffbc67",
      WebkitBoxShadow: 0,
      MozBoxShadow: 0,
      boxShadow: 0
    },

    info: {
      borderTop: 0,
      backgroundColor: "#63d8f1",
      WebkitBoxShadow: 0,
      MozBoxShadow: 0,
      boxShadow: 0
    }
  },

  Title: {
    DefaultStyle: {
      fontSize: "30px",
      margin: "0",
      padding: 0,
      fontWeight: "bold",
      color: "#FFFFFF",
      display: "block",
      left: "15px",
      position: "absolute",
      top: "50%",
      marginTop: "-15px"
    }
  },

  MessageWrapper: {
    DefaultStyle: {
      marginLeft: "55px",
      marginRight: "30px",
      padding: "0 12px 0 0",
      color: "#FFFFFF",
      maxWidthwidth: "89%"
    }
  },

  Dismiss: {
    DefaultStyle: {
      fontFamily: "inherit",
      fontSize: "21px",
      color: "#000",
      float: "right",
      position: "absolute",
      right: "10px",
      top: "50%",
      marginTop: "-13px",
      backgroundColor: "#FFFFFF",
      display: "block",
      borderRadius: "50%",
      opacity: ".4",
      lineHeight: "11px",
      width: "25px",
      height: "25px",
      outline: "0 !important",
      textAlign: "center",
      padding: "6px 3px 3px 3px",
      fontWeight: "300",
      marginLeft: "65px"
    },

    success: {
    },

    error: {
    },

    warning: {

    },

    info: {
    }
  },

  Action: {
    DefaultStyle: {
      background: "#ffffff",
      borderRadius: "2px",
      padding: "6px 20px",
      fontWeight: "bold",
      margin: "10px 0 0 0",
      border: 0
    },

    success: {
      backgroundColor: "#a1e82c",
      color: "#ffffff"
    },

    error: {
      backgroundColor: "#fc727a",
      color: "#ffffff"
    },

    warning: {
      backgroundColor: "#ffbc67",
      color: "#ffffff"
    },

    info: {
      backgroundColor: "#63d8f1",
      color: "#ffffff"
    }
  },

  ActionWrapper: {
    DefaultStyle: {
      margin: 0,
      padding: 0
    }
  }
};

//
// //
// // // For tables
// //
//
const thArray = ["#","Role Name", "Customer Name"];
const tdArray = [
  ["1","Warehouse Manager", "Valvoline"],
  ["2","Valvoline Role", "Valvoline"],
  ["3","Production Manager", "Valvoline"],
  ["4","Dispatch Manager", "Valvoline"],
  ["5","Depot Manager", "Valvoline"],
  ["6","Delivery Manager", "Valvoline"],
];

//
// //
// // // For icons
// //
//
const iconsArray = [
  "pe-7s-album",
  "pe-7s-arc",
  "pe-7s-back-2",
  "pe-7s-bandaid",
  "pe-7s-car",
  "pe-7s-diamond",
  "pe-7s-door-lock",
  "pe-7s-eyedropper",
  "pe-7s-female",
  "pe-7s-gym",
  "pe-7s-hammer",
  "pe-7s-headphones",
  "pe-7s-helm",
  "pe-7s-hourglass",
  "pe-7s-leaf",
  "pe-7s-magic-wand",
  "pe-7s-male",
  "pe-7s-map-2",
  "pe-7s-next-2",
  "pe-7s-paint-bucket",
  "pe-7s-pendrive",
  "pe-7s-photo",
  "pe-7s-piggy",
  "pe-7s-plugin",
  "pe-7s-refresh-2",
  "pe-7s-rocket",
  "pe-7s-settings",
  "pe-7s-shield",
  "pe-7s-smile",
  "pe-7s-usb",
  "pe-7s-vector",
  "pe-7s-wine",
  "pe-7s-cloud-upload",
  "pe-7s-cash",
  "pe-7s-close",
  "pe-7s-bluetooth",
  "pe-7s-cloud-download",
  "pe-7s-way",
  "pe-7s-close-circle",
  "pe-7s-id",
  "pe-7s-angle-up",
  "pe-7s-wristwatch",
  "pe-7s-angle-up-circle",
  "pe-7s-world",
  "pe-7s-angle-right",
  "pe-7s-volume",
  "pe-7s-angle-right-circle",
  "pe-7s-users",
  "pe-7s-angle-left",
  "pe-7s-user-female",
  "pe-7s-angle-left-circle",
  "pe-7s-up-arrow",
  "pe-7s-angle-down",
  "pe-7s-switch",
  "pe-7s-angle-down-circle",
  "pe-7s-scissors",
  "pe-7s-wallet",
  "pe-7s-safe",
  "pe-7s-volume2",
  "pe-7s-volume1",
  "pe-7s-voicemail",
  "pe-7s-video",
  "pe-7s-user",
  "pe-7s-upload",
  "pe-7s-unlock",
  "pe-7s-umbrella",
  "pe-7s-trash",
  "pe-7s-tools",
  "pe-7s-timer",
  "pe-7s-ticket",
  "pe-7s-target",
  "pe-7s-sun",
  "pe-7s-study",
  "pe-7s-stopwatch",
  "pe-7s-star",
  "pe-7s-speaker",
  "pe-7s-signal",
  "pe-7s-shuffle",
  "pe-7s-shopbag",
  "pe-7s-share",
  "pe-7s-server",
  "pe-7s-search",
  "pe-7s-film",
  "pe-7s-science",
  "pe-7s-disk",
  "pe-7s-ribbon",
  "pe-7s-repeat",
  "pe-7s-refresh",
  "pe-7s-add-user",
  "pe-7s-refresh-cloud",
  "pe-7s-paperclip",
  "pe-7s-radio",
  "pe-7s-note2",
  "pe-7s-print",
  "pe-7s-network",
  "pe-7s-prev",
  "pe-7s-mute",
  "pe-7s-power",
  "pe-7s-medal",
  "pe-7s-portfolio",
  "pe-7s-like2",
  "pe-7s-plus",
  "pe-7s-left-arrow",
  "pe-7s-play",
  "pe-7s-key",
  "pe-7s-plane",
  "pe-7s-joy",
  "pe-7s-photo-gallery",
  "pe-7s-pin",
  "pe-7s-phone",
  "pe-7s-plug",
  "pe-7s-pen",
  "pe-7s-right-arrow",
  "pe-7s-paper-plane",
  "pe-7s-delete-user",
  "pe-7s-paint",
  "pe-7s-bottom-arrow",
  "pe-7s-notebook",
  "pe-7s-note",
  "pe-7s-next",
  "pe-7s-news-paper",
  "pe-7s-musiclist",
  "pe-7s-music",
  "pe-7s-mouse",
  "pe-7s-more",
  "pe-7s-moon",
  "pe-7s-monitor",
  "pe-7s-micro",
  "pe-7s-menu",
  "pe-7s-map",
  "pe-7s-map-marker",
  "pe-7s-mail",
  "pe-7s-mail-open",
  "pe-7s-mail-open-file",
  "pe-7s-magnet",
  "pe-7s-loop",
  "pe-7s-look",
  "pe-7s-lock",
  "pe-7s-lintern",
  "pe-7s-link",
  "pe-7s-like",
  "pe-7s-light",
  "pe-7s-less",
  "pe-7s-keypad",
  "pe-7s-junk",
  "pe-7s-info",
  "pe-7s-home",
  "pe-7s-help2",
  "pe-7s-help1",
  "pe-7s-graph3",
  "pe-7s-graph2",
  "pe-7s-graph1",
  "pe-7s-graph",
  "pe-7s-global",
  "pe-7s-gleam",
  "pe-7s-glasses",
  "pe-7s-gift",
  "pe-7s-folder",
  "pe-7s-flag",
  "pe-7s-filter",
  "pe-7s-file",
  "pe-7s-expand1",
  "pe-7s-exapnd2",
  "pe-7s-edit",
  "pe-7s-drop",
  "pe-7s-drawer",
  "pe-7s-download",
  "pe-7s-display2",
  "pe-7s-display1",
  "pe-7s-diskette",
  "pe-7s-date",
  "pe-7s-cup",
  "pe-7s-culture",
  "pe-7s-crop",
  "pe-7s-credit",
  "pe-7s-copy-file",
  "pe-7s-config",
  "pe-7s-compass",
  "pe-7s-comment",
  "pe-7s-coffee",
  "pe-7s-cloud",
  "pe-7s-clock",
  "pe-7s-check",
  "pe-7s-chat",
  "pe-7s-cart",
  "pe-7s-camera",
  "pe-7s-call",
  "pe-7s-calculator",
  "pe-7s-browser",
  "pe-7s-box2",
  "pe-7s-box1",
  "pe-7s-bookmarks",
  "pe-7s-bicycle",
  "pe-7s-bell",
  "pe-7s-battery",
  "pe-7s-ball",
  "pe-7s-back",
  "pe-7s-attention",
  "pe-7s-anchor",
  "pe-7s-albums",
  "pe-7s-alarm",
  "pe-7s-airplay"
];

//
// //
// // // // For dashboard's charts
// //
//

// Data for Pie Chart **************************************************************
var dataPieAgeing = {
  labels: ["20%", "20%", "60%"],
  series: [20, 20, 60]
};
var legendPieAgeing = {
  names: ["  >100 Days  ", "  <40 Days  ", "  Others  "],
  types: ["info", "danger", "warning"]
};

// Data for Pie Chart **************************************************************
var dataPieFifo = {
  labels: ["40%", "50%", "30%"],
  series: [30, 40, 30],
};
var legendPieFifo = {
  names: ["  Kolkata  ", "  Hyderabad  ", "  Chennai  "],
  types: ["info", "danger", "warning"]
};

// Data for Pie Chart **************************************************************
var dataPieInventory = {
  labels: ["70%", "15%", "15%"],
  series: [70, 19, 11]
};
var legendPieInventory = {
  names: ["  Hyderabad  ", "  Chennai  ", "  Kolkata  "],
  types: ["info", "danger", "warning"]
};

// Data for Pie Chart **************************************************************
var dataPieQc = {
  labels: ["10%", "25%", "Maximum Failures"],
  series: [10, 25, 65]
};
var legendPieQc = {
  names: ["  Mumbai  ", "  Kolkata  ", "  Hyderabad  "],
  types: ["info", "danger", "warning"]
};

// Data for Pie Chart **************************************************************
var dataPieWip = {
  labels: ["45% of Ops", "35%", "20%"],
  series: [45, 35, 20]
};
var legendPieWip = {
  names: ["  Engineering-1  ", "  Finished  ", "  Finalised  "],
  types: ["info", "danger", "warning"]
};

// Data for Line Chart **************************************************************
var dataSalesAgeing = {
  labels: [
    "9:00AM",
    "12:00AM",
    "3:00PM",
    "6:00PM",
    "9:00PM",
    "12:00PM",
    "3:00AM",
    "6:00AM"
  ],
  series: [
    [87, 85, 50, 92, 54, 86, 38, 65],
    [67, 52, 43, 40, 87, 35, 35, 47],
    [23, 13, 67, 18, 10, 29, 37, 38]
  ]
};
var optionsSalesAgeing = {
  low: 0,
  high: 100,
  showArea: false,
  height: "245px",
  axisX: {
    showGrid: false
  },
  lineSmooth: true,
  showLine: true,
  showPoint: true,
  fullWidth: true,
  chartPadding: {
    right: 50
  }
};
var responsiveSalesAgeing = [
  [
    "screen and (max-width: 640px)",
    {
      axisX: {
        labelInterpolationFnc: function(value) {
          return value[0];
        }
      }
    }
  ]
];
var legendSalesAgeing = {
  names: ["  Open  ", "  Click  ", "  Click Second Time  "],
  types: ["info", "danger", "warning"]
};

// Data for Line Chart **************************************************************
var dataSalesInventory = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
  ],
  series: [
    [287, 385, 490, 492, 554, 586, 698, 695],
    [67, 152, 143, 240, 287, 335, 435, 437],
    [23, 113, 67, 108, 190, 239, 307, 308]
  ]
};
var optionsSalesInventory = {
  low: 0,
  high: 800,
  showArea: false,
  height: "245px",
  axisX: {
    showGrid: false
  },
  lineSmooth: true,
  showLine: true,
  showPoint: true,
  fullWidth: true,
  chartPadding: {
    right: 50
  }
};
var responsiveSalesInventory = [
  [
    "screen and (max-width: 640px)",
    {
      axisX: {
        labelInterpolationFnc: function(value) {
          return value[0];
        }
      }
    }
  ]
];
var legendSalesInventory = {
  names: ["  Product A  ", "  Product B  ", "  Product C  "],
  types: ["info", "danger", "warning"]
};

// Data for Line Chart **************************************************************
var dataSalesFifo = {
  labels: [
    "9:00AM",
    "12:00AM",
    "3:00PM",
    "6:00PM",
    "9:00PM",
    "12:00PM",
    "3:00AM",
    "6:00AM"
  ],
  series: [
    {
      name: 'series-1',
      data: [3, 5, 6, 2, 0, -2, 5, -3]
    }, {
      name: 'series-2',
      data: [0, 0, 0, 4, 8, 8, 8, 8]
    }, {
      name: 'series-3',
      data: [2, 2, 2, 2, -2, -2, -2, -2]
    }
  ]
};
var optionsSalesFifo = {
  showArea: true,
  height: "245px",
  axisX: {
    showGrid: true
  },
  lineSmooth: false,
  showLine: true,
  showPoint: true,
  fullWidth: true,
  chartPadding: {
    right: 50
  }
};
var responsiveSalesFifo = [
  [
    "screen and (max-width: 640px)",
    {
      axisX: {
        labelInterpolationFnc: function(value) {
          return value[0];
        }
      }
    }
  ]
];
var legendSalesFifo = {
  names: ["  Batch 201907  ", "  Batch 201908  ","  Ideal Compliance Track (for an independent batch)  "],
  types: ["info", "danger", "warning"]
};

// Data for Line Chart **************************************************************
var dataSalesWip = {
  labels: [
    "Material",
    "Refine",
    "Extract",
    "Prototype",
    "Engineering-1",
    "Finished",
    "Finalised"
  ],
  series: [
    {
      name: 'series-1',
      data: [400, 200, 300, 500, 400, 500, 300]
    }, {
      name: 'series-2',
      data: [200, 200, 200, 400, 300, 400, 200]
    }
  ]
};
var optionsSalesWip = {
  low: 100,
  high: 1000,
  showArea: true,
  height: "245px",
  axisX: {
    showGrid: true
  },
  lineSmooth: false,
  showLine: true,
  showPoint: true,
  fullWidth: true,
  chartPadding: {
    right: 50
  }
};
var responsiveSalesWip = [
  [
    "screen and (max-width: 640px)",
    {
      axisX: {
        labelInterpolationFnc: function(value) {
          return value[0];
        }
      }
    }
  ]
];
var legendSalesWip = {
  names: ["  Product A  ", "  Product B  "],
  types: ["info", "danger", "warning"]
};

// Data for Bar Chart **************************************************************
var dataBarAgeing = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    /*"Oct",
    "Nov",
    "Dec"*/
  ],
  series: [
    [52, 43, 32, 78, 53, 43, 26, 34, 68/*, 610, 756, 895*/],
    [42, 23, 20, 50, 43, 33, 30, 34, 38/* 410, 636, 695*/]
  ]
};
var optionsBarAgeing = {
  seriesBarDistance: 10,
  axisX: {
    showGrid: false
  },
  height: "245px"
};
var responsiveBarAgeing = [
  [
    "screen and (max-width: 640px)",
    {
      seriesBarDistance: 5,
      axisX: {
        labelInterpolationFnc: function(value) {
          return value[0];
        }
      }
    }
  ]
];
var legendBarAgeing = {
  names: ["  Non QR Coverage will be made available once integration with WMS is completed "],
  //types: ["info", "danger"]
};

var legendBarAgeing2 = {
  names: [" The Non Live data is not available yet. The values shown for Non Live are dummy "],
  //types: ["info", "danger"]
};

// Data for Bar Chart **************************************************************
var dataBarInventory = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    /*"Oct",
    "Nov",
    "Dec"*/
  ],
  series: [
    [542, 443, 320, 780, 553, 453, 326, 434, 568/*, 610, 756, 895*/],
    [412, 243, 280, 580, 453, 353, 300, 364, 368/* 410, 636, 695*/]
  ]
};
var optionsBarInventory = {
  seriesBarDistance: 10,
  axisX: {
    showGrid: false
  },
  height: "245px"
};
var responsiveBarInventory = [
  [
    "screen and (max-width: 640px)",
    {
      seriesBarDistance: 5,
      axisX: {
        labelInterpolationFnc: function(value) {
          return value[0];
        }
      }
    }
  ]
];
var legendBarInventory = {
  names: ["  Tesla Model S  ", "  BMW 5 Series  "],
  types: ["info", "danger"]
};

// Data for Bar Chart **************************************************************
var dataBarQc = {
  labels: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    /*"Oct",
    "Nov",
    "Dec"*/
  ],
  series: [
    [42, 43, 20, 70, 53, 43, 26, 34, 68/*, 610, 756, 895*/],
    [12, 23, 40, 80, 53, 53, 2, 64, 38/* 410, 636, 695*/]
  ]
};
var optionsBarQc = {
  seriesBarDistance: 10,
  horizontalBars: true,
  axisX: {
    showGrid: false
  },
  height: "245px"
};
var responsiveBarQc = [
  [
    "screen and (max-width: 640px)",
    {
      seriesBarDistance: 5,
      axisX: {
        labelInterpolationFnc: function(value) {
          return value[0];
        }
      }
    }
  ]
];
var legendBarQc = {
  names: ["  Product A  ", "  Product B  "],
  types: ["info", "danger"]
};

var months = [
  'October',
  'November',
  'December',
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
]
var QRDataPacking = [
  0,
  0,
  0,
  11945465.5,
  11018705.5,
  14056220.4,
  0,
  0,
  0,
  0,
  0,
  0
]

var QRDataPutAway = [
  0,
  0,
  0,
  4775766.8,
  4564998.4,
  6076387.4,
  0,
  0,
  0,
  0,
  0,
  0
]

var QRDataSalesAmbernath = [
  0,
  0,
  0,
  91006.4,
  114915.5,
  184912,
  0,
  0,
  0,
  0,
  0,
  0
]

var QRDataStockTransfer = [
  0,
  0,
  0,
  7337880,
  8574923.9,
  9781166.3,
  0,
  0,
  0,
  0,
  0,
  0
]

var QRDataReceive = [
  0,
  0,
  0,
  1438812.2,
  2235174.1,
  3121972.1,
  0,
  0,
  0,
  0,
  0,
  0
]

var QRDataSales = [
  0,
  0,
  0,
  2314742.7,
  2675694.3,
  2451389.8,
  0,
  0,
  0,
  0,
  0,
  0
]
const monthlyProduction2019 = {
  months: [
    'October',
    'November',
    'December',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
  ],
  monthWiseIOTCount: [
    6128406.5,
    5132693.1,
    5620971.5,
    2588640,
    3405429,
    6232549.8,
    9670537.4,
    5416850,
    6198449,
    4861213,
    4447032.5,
    3930440.5
  ]
};
const monthlyDispatch2019 = {
  months: [
    'October',
    'November',
    'December',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
  ],
  monthWiseIOTCount: [
    7566301.3,
    8323767.7,
    8088334.6,
    1322936,
    3321972,
    6255577.9,
    6359445.2,
    6948373.1,
    8100527.2,
    7200307.2,
    6574622.6,
    6049493.4
  ]
};
const monthlyProduction2020 = {
  months: [
    'October',
    'November',
    'December',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
  ],
  monthWiseIOTCount: [
    10477870.3,
    8858862.2,
    9786795.1,
    4935362.3,
    5114921.5,
    4515156.5,
    0,
    666564.5,
    4108937.5,
    4933099,
    4149933,
    7280309.8
  ]
};
const monthlyDispatch2020 = {
  months: [
    'October',
    'November',
    'December',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
  ],
  monthWiseIOTCount: [
    11563686.8,
    10680627.9,
    10542009.5,
    6270110.9,
    6707027.1,
    4299042.5,
    506607,
    831754.4,
    4328748.6,
    5960793,
    5872188.1,
    7040159.3
  ]
};
const monthlyProduction2021 = {
  months: [
    'October',
    'November',
    'December',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
  ],
  monthWiseIOTCount: [
    7128543.4,
    6519879.3,
    8006934.1,
    7759655.5,
    8501225.5,
    9540740.4,
    5898721,
    3557247.4,
    5641807.9,
    6561263.5,
    7020246,
    6797448.7
  ]
};
const monthlyDispatch2021 = {
  months: [
    'October',
    'November',
    'December',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
  ],
  monthWiseIOTCount: [
    10725183.2,
    8524876.5,
    10055018.7,
    9177247.2,
    10975271.2,
    11346323.1,
    7246135.2,
    3680980.7,
    8370178.1,
    8959064.7,
    8674942.2,
    8920053.4
  ]
};
const monthlyProductionDefault = {
  months: [
    'October',
    'November',
    'December',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
  ],
  monthWiseIOTCount: [
    7128543.4,
    6519879.3,
    8006934.1,
    7759655.5,
    8501225.5,
    9540740.4,
    5898721,
    3557247.4,
    5641807.9,
    6561263.5,
    7020246,
    6797448.7
  ]
};
const monthlyDispatchDefault = {
  months: [
    'October',
    'November',
    'December',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
  ],
  monthWiseIOTCount: [
    10725183.2,
    8524876.5,
    10055018.7,
    9177247.2,
    10975271.2,
    11346323.1,
    7246135.2,
    3680980.7,
    8370178.1,
    8959064.7,
    8674942.2,
    8920053.4
  ]
};
var productionMonthWiseData2019 = [
    28746923, 
    49376819, 
    31958652, 
    38378358,        
    28925591,    
    0,  
    0, 
    0, 
    0, 
    0, 
    0,
    0
]
var qrTimelineData2019 = [
  6487213,
  5327123,
  4705424,
  5000000,
  4000000
]
var monthlyDispatchData2019 = [
    18746923, 
    39376819, 
    21958652, 
    18378358,        
    18925591,    
    0,  
    0, 
    0, 
    0, 
    0, 
    0,
    0
]
var monthlyReceiveData2019 = [
    18746923, 
    39376819, 
    21958652, 
    28378358,        
    18925591,    
    0,  
    0, 
    0, 
    0, 
    0, 
    0,
    0
]
var monthlyUsedIOT2020 = [
  1415097,
  1444869,
  1442523,
  1401592,
  998958,
  0,
  0,
  0,
  0,
  0,
  0,
  0
]
// Exports **************************************************************
module.exports = {
  style, // For notifications (App container and Notifications view)
  thArray,
  tdArray, // For tables (TableList view)
  iconsArray, // For icons (Icons view)
  dataPieAgeing,
  legendPieAgeing,
  dataSalesAgeing,
  optionsSalesAgeing,
  responsiveSalesAgeing,
  legendSalesAgeing,
  dataBarAgeing,
  optionsBarAgeing,
  responsiveBarAgeing,
  legendBarAgeing, // For charts (Dashboard view)
  legendBarAgeing2, // For charts (Dashboard view)

  dataPieInventory,
  legendPieInventory,
  dataSalesInventory,
  optionsSalesInventory,
  responsiveSalesInventory,
  legendSalesInventory,
  dataBarInventory,
  optionsBarInventory,
  responsiveBarInventory,
  legendBarInventory, // For charts (Dashboard view)

  dataPieFifo,
  legendPieFifo,
  dataSalesFifo,
  optionsSalesFifo,
  responsiveSalesFifo,
  legendSalesFifo, // For charts (Dashboard view)

  dataPieQc,
  legendPieQc,
  dataBarQc,
  optionsBarQc,
  responsiveBarQc,
  legendBarQc,  // For charts 

  dataPieWip,
  legendPieWip,
  dataSalesWip,
  optionsSalesWip,
  responsiveSalesWip,
  legendSalesWip, // For charts (Dashboard view)
  months,
  productionMonthWiseData2019,
  qrTimelineData2019,
  monthlyDispatchData2019,
  monthlyReceiveData2019,
  monthlyUsedIOT2020,
  QRDataPacking,QRDataPutAway,QRDataSalesAmbernath,
  QRDataStockTransfer,QRDataReceive,QRDataSales,
  monthlyProduction2021,monthlyDispatch2021,
  monthlyProduction2020,monthlyDispatch2020,
  monthlyProduction2019,monthlyDispatch2019,
  monthlyProductionDefault,monthlyDispatchDefault

};
